// Market-reference registry.
//
// Drives the /predictions/bookmaker/:slug pages plus the /jackpot-predictions
// hub. These pages are neutral statistical references: they explain how widely
// quoted market prices for a multi-fixture coupon compare with Statlign's model
// probabilities. They do not promote, rank or recommend any operator, carry no
// offers or referral links, and exist purely as analysis of publicly quoted
// prices for the fixtures involved.

export interface Bookmaker {
  slug: string;
  /** Operator whose publicly quoted coupon prices are referenced. */
  name: string;
  /** Region the coupon is commonly quoted in. */
  market: string;
  /** Neutral page subject, e.g. "SportPesa Mega Jackpot coupon analysis". */
  jackpotName: string;
  /** Search phrasings readers use to find this analysis. */
  aliases: string[];
}

export const BOOKMAKERS: Bookmaker[] = [
  {
    slug: "sportpesa",
    name: "SportPesa",
    market: "Kenya",
    jackpotName: "SportPesa Mega Jackpot Coupon Analysis",
    aliases: ["sportpesa mega jackpot", "sportpesa kenya jackpot", "sport pesa mega jackpot", "jackpot prediction sportpesa"],
  },
  {
    slug: "betika",
    name: "Betika",
    market: "Kenya",
    jackpotName: "Betika Grand Jackpot Coupon Analysis",
    aliases: ["betika prediction", "betika grand jackpot", "betika midweek jackpot", "betika all games today football predictions"],
  },
  {
    slug: "bet9ja",
    name: "Bet9ja",
    market: "Nigeria",
    jackpotName: "Bet9ja Coupon Price Analysis",
    aliases: ["bet9ja prediction", "bet9ja booking code"],
  },
  {
    slug: "sportybet",
    name: "SportyBet",
    market: "Nigeria",
    jackpotName: "SportyBet Coupon Price Analysis",
    aliases: ["sportybet prediction", "sporty bet prediction"],
  },
  {
    slug: "betpawa",
    name: "betPawa",
    market: "Africa",
    jackpotName: "betPawa Coupon Price Analysis",
    aliases: ["betpawa prediction", "bet pawa prediction"],
  },
  {
    slug: "odibets",
    name: "Odibets",
    market: "Kenya",
    jackpotName: "Odibets Coupon Price Analysis",
    aliases: ["odibets predictions", "odi bets prediction"],
  },
];

export function findBookmaker(slug: string): Bookmaker | undefined {
  return BOOKMAKERS.find((b) => b.slug === slug);
}

export const BOOKMAKER_ROUTES = BOOKMAKERS.map((b) => `/predictions/bookmaker/${b.slug}`);
